import React from 'react';
import {Header,Item, Label,  Statistic, Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import ReactEcharts from "echarts-for-react";
import {moneda} from '../../util/';
 


const InscripcionIndicadores=({ id, ventaInvMf, idCurso, ajaxCallInProgress,reporte, strings, total, totalPagado, totalPagos,totalPendiente, sinRegistrosDePago,montoSinRegistroDePago, egresosIngresos, totalGastos,axisvalores})=>{

	return (
        <Container>
        {idCurso<=0 || idCurso==null?"Seleccióne un curso":
         
         <div>
         <Divider />
         <Grid columns={6} textAlign="center" divided>
            <Grid.Row>
              <Grid.Column>
                <Statistic size="tiny" color='blue'>
                    <Statistic.Label>Alumnos</Statistic.Label>
                    <Statistic.Value>{reporte.inscripcion.length}</Statistic.Value>
                </Statistic>
              </Grid.Column>
            <Grid.Column>
                <Statistic size="tiny" color='green'>
                    <Statistic.Label>Ingreso total</Statistic.Label>
                    <Statistic.Value>{moneda(total)}</Statistic.Value>
                </Statistic>
              </Grid.Column>
        
            
            <Grid.Column>
                <Statistic size="tiny" color='red'>
                    <Statistic.Label>Monto Pagado</Statistic.Label>
                    <Statistic.Value>{moneda(totalPagos)}</Statistic.Value>
                </Statistic>
              </Grid.Column>
        
                <Grid.Column>
                <Statistic size="tiny" color='red'>
                    <Statistic.Label>Monto Pendiente</Statistic.Label>
                    <Statistic.Value>{moneda(totalPendiente)}</Statistic.Value>
                </Statistic>
              </Grid.Column>
             
            <Grid.Column>
                <Statistic size="tiny" color='orange'>
                    <Statistic.Label>Alumnos Sin registro de pago</Statistic.Label>
                    <Statistic.Value>{sinRegistrosDePago}</Statistic.Value>
                </Statistic>
              </Grid.Column>
            <Grid.Column>
                <Statistic size="tiny" color='orange'>
                    <Statistic.Label>Alumnos sin registro monto</Statistic.Label>
                    <Statistic.Value>{moneda(montoSinRegistroDePago)}</Statistic.Value>
                </Statistic>
              </Grid.Column>        
                    
            </Grid.Row>
        </Grid>
         <Divider />
        
        
            <ReactEcharts
         
                          
                        option={
                            {
                            dataset: [
                              {
                                id: 'dataset_raw',
                                source: ventaInvMf
                              },
                             
                              {
                                id: 'dataset_esperado',
                                fromDatasetId: 'dataset_raw',
                                transform: {
                                  type: 'filter',
                                  config: {
                                    and: [
                        
                                      { dimension: 'Estatus', '=': 'Esperado' }
                                    ]
                                  }
                                }
                              },
                                {
                                id: 'dataset_pagado',
                                fromDatasetId: 'dataset_raw',
                                transform: {
                                  type: 'filter',
                                  config: {
                                    and: [
                       
                                      { dimension: 'Estatus', '=': 'Ingresado' }
                                    ]
                                  }
                                }
                              }
                            ],
                            title: {
                              text: 'Ingresos estimados vs reales'
                            },
                            tooltip: {
                              trigger: 'axis'
                            },
                            xAxis: {
                              type: 'category',
                              nameLocation: 'middle'
                            },
                            yAxis: {
                              name: 'Ingreso'
                            },
                                
                            
                            series: [
                              {
                               
                                type: 'line',
                                datasetId: 'dataset_esperado',
                                showSymbol: false,
                                encode: {
                                  x: 'Periodo',
                                  y: 'monto',
                                  itemName: 'Periodo',
                                  tooltip: ['Estatus','monto']
                                }
                              },
                             {
                                type: 'line',
                                datasetId: 'dataset_pagado',
                                showSymbol: false,
                                encode: {
                                  x: 'Periodo',
                                  y: 'monto',
                                  itemName: 'Periodo',
                                  tooltip: ['Estatus','monto']
                                }
                              }
                            ]
                          }
                            
                        }
                      />
        
        
        
         </div>

        }
                      
                      
         <Grid columns={2} textAlign="center" divided>
            <Grid.Row>
              <Grid.Column>
                <Statistic size="tiny" color='green'>
                    <Statistic.Label>Ingreso </Statistic.Label>
                    <Statistic.Value>{moneda(total)}</Statistic.Value>
                </Statistic>
              </Grid.Column>
            <Grid.Column>
                <Statistic size="tiny" color='red'>
                    <Statistic.Label>Egreso</Statistic.Label>
                    <Statistic.Value>{moneda(totalGastos)}</Statistic.Value>
                </Statistic>
              </Grid.Column>
          </Grid.Row>
        </Grid>     
                
        <Divider />
                    
                    {egresosIngresos.length>0?    
     
                    <ReactEcharts
         
                          
                        option={
                            {
                            dataset: [
                              {
                                id: 'dataset_raw1',
                                source: egresosIngresos
                              },
                             
                              {
                                id: 'dataset_ingreso',
                                fromDatasetId: 'dataset_raw1',
                                transform: {
                                  type: 'filter',
                                  config: {
                                    and: [
                        
                                      { dimension: 'Estatus', '=': 'Ingresó' }
                                    ]
                                  }
                                }
                              },
                                {
                                id: 'dataset_pagado',
                                fromDatasetId: 'dataset_raw1',
                                transform: {
                                  type: 'filter',
                                  config: {
                                    and: [
                       
                                      { dimension: 'Estatus', '=': 'Gasto' }
                                    ]
                                  }
                                }
                              }
                            ],
                            title: {
                              text: 'Ingresos vs Egresos'
                            },
                            tooltip: {
                              trigger: 'axis'
                            },
                            xAxis: {
                              type: 'category',
                              nameLocation: 'middle',
                              data: axisvalores
                            },
                            yAxis: {
                              name: 'Ingreso y egreso'
                            },
                                
                            
                            series: [
                              {
                               
                                type: 'line',
                                datasetId: 'dataset_ingreso',
                                showSymbol: false,
                                encode: {
                                  x: 'Periodo',
                                  y: 'monto',
                                  itemName: 'Periodo',
                                  tooltip: ['Estatus','monto']
                                }
                              },
                              {
                               
                                type: 'line',
                                datasetId: 'dataset_pagado',
                                showSymbol: true,
                                encode: {
                                  x: 'Periodo',
                                  y: 'monto',
                                  itemName: 'Periodo',
                                  tooltip: ['Estatus','monto']
                                }
                              }
                            ]
                          }
                            
                        }
                      />
                      
                      :
                      
                        ""
                      
                        }
                    
        
        </Container>
	);
};



export default InscripcionIndicadores;